module.exports = __webpack_public_path__ + "static/media/mark-2.da65e040.png";